export const featureKey = 'workspace-app';
